import { cn } from '../../lib/utils';

export interface TokenMeterProps {
  used: number;
  total: number;
  /** Optional threshold for warning state (0-1). Default: 0.9 */
  warnAt?: number;
  className?: string;
}

/**
 * Usage meter for token quota. Changes color at warn threshold.
 */
export function TokenMeter({ used, total, warnAt = 0.9, className }: TokenMeterProps) {
  const pct = Math.min(1, used / total);
  const isWarning = pct >= warnAt;

  return (
    <div className={cn('w-full', className)}>
      <div
        className="h-1.5 overflow-hidden rounded-pill bg-neutral-200"
        role="progressbar"
        aria-valuenow={used}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-label={`${used.toLocaleString()} of ${total.toLocaleString()} tokens used`}
      >
        <div
          className={cn(
            'h-full rounded-pill transition-all duration-base',
            isWarning
              ? 'bg-gradient-to-r from-warning-400 to-error-400'
              : 'bg-gradient-to-r from-brand-400 to-brand-500'
          )}
          style={{ width: `${(pct * 100).toFixed(2)}%` }}
        />
      </div>
      <div className="mt-1.5 flex items-center justify-between font-mono text-[11px] text-text-tertiary">
        <span>Daily usage</span>
        <span>
          {used.toLocaleString()} / {total.toLocaleString()}
        </span>
      </div>
    </div>
  );
}
